type FontDetails = {
    baseName: string;
    fontName: string;
    format: string;
    fontWeight: number | null;
    fontStyle: string;
};

interface Font {
    name: string;
    url: string;
}

interface FontCollection {
    name: string;
    url: string;
    collection?: Font[];
}

interface FontGroups {
    google: FontCollection[];
    custom: FontCollection[];
}
export function handleCustomFontFace(fileName: string): FontDetails {
    const [baseName, extension = ""] = fileName?.includes(".")
        ? fileName.split(".")
        : [fileName, ""];

    const formatMap: { [key: string]: string } = {
        ttf: "TrueType",
        otf: "OpenType",
        woff: "WOFF",
        woff2: "WOFF2",
        eot: "Embedded OpenType",
        svg: "SVG Font",
    };

    const format = formatMap[extension?.toLowerCase()] || "Unknown Format";
    const parts = baseName.split("-");
    const fontName = parts.slice(0, parts.length - 1).join(" ");
    const stylePart = parts[parts.length - 1]?.toLowerCase() || "";

    const weightMap: { [key: string]: number } = {
        thin: 100,
        hairline: 100,
        extralight: 200,
        ultralight: 200,
        light: 300,
        regular: 400,
        normal: 400,
        book: 400,
        medium: 500,
        semibold: 600,
        demibold: 600,
        bold: 700,
        extrabold: 800,
        ultrabold: 800,
        black: 900,
        heavy: 900,
    };
    let fontWeight = null;
    let fontStyle = "normal";
    if (stylePart?.includes("italic")) {
        fontStyle = "italic";
    }

    Object.keys(weightMap).forEach((key) => {
        if (stylePart?.includes(key)) {
            fontWeight = weightMap[key];
        }
    });

    return {
        baseName,
        fontName,
        format,
        fontWeight,
        fontStyle,
    };
}
export const transformFonts = (fonts: Font[]): FontGroups => {
    const getFamilyName = (name: string): string => {
        const parts = name?.split("-");
        return parts?.length > 1 ? parts?.slice(0, -1)?.join(" ") : name;
    };

    const fontMap: Record<string, FontCollection> = {};
    const googleFonts: FontCollection[] = [];
    const customFonts: FontCollection[] = [];

    fonts?.forEach((font) => {
        const familyName = getFamilyName(font?.name);

        if (!fontMap[familyName]) {
            fontMap[familyName] = {
                name: familyName,
                url: "",
                collection: [], // Initial collection setup for potential custom fonts
            };
        }
        if(fontMap[familyName]?.collection) {
            fontMap[familyName]?.collection.push({ name: font.name, url: font.url });
        }
    });

    Object?.keys(fontMap)?.forEach((familyName) => {
        const family = fontMap[familyName];
        if(family?.collection) {
            const regularFont = family.collection.find((font) =>
                font.name.includes("Regular")
            );
            family.url = regularFont ? regularFont.url : family.collection[0].url;
        }
        if (family?.url?.includes("fonts.googleapis.com") || family?.url === "") {
            googleFonts.push({
                name: family.name,
                url: family.url,
            }); 
        } else {
            customFonts.push(family);
        }
    });

    return {
        google: googleFonts,
        custom: customFonts,
    };
};